
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import utils from './../../utils/utilities';
import xhr from './../../utils/xhr';
import {POST} from './../../constants';
import reduxStore from './../../reduxStore';
import InfiniteScrollTable from './../InfiniteScrollTable/InfiniteScrollTable.index.jsx';
import CustomTableBodyPostParamsWrapper from './../../reusable/CustomTableBody/CustomTableBodyPostParamsWrapper';
import CountBox from './../CountBox/CountBox.index';
import SortIndicator from '../SortIndicators/SortIndicators.index';
import api from './../../api/Common.api';
import {
    TitleCellNoLink,
    PESTLEContentCell,
    DateContentCell,
    SimpleArrayCell,
    LanguageCell
} from './../CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';

class ArticlesTable extends Component {
    static propTypes = {
        url: PropTypes.string,
        countUrl: PropTypes.string,
        urlParams: PropTypes.object,
        showArticleView: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            urlParams: Object.assign(
                {},
                this.props.urlParams,
                {
                    sortBy:    'date',
                    direction: 'desc',
                    languages: this.props.urlParams.languages || utils.extractLanguagesFilter(reduxStore.getState().user.preferences.filters.languageFilter)
                }
            ),
            lastTimestamp: null,
            articleCount : null
        };

        this.articleClickHandler = this.articleClickHandler.bind(this);
        this.initQuery = this.initQuery.bind(this);
        this.refreshData = this.refreshData.bind(this);
        this.sortByDate = this.sortByDate.bind(this);
        this.changeUrlParams = this.changeUrlParams.bind(this);

        this.columnWidths = [50, 8, 10, 10, 22];
        this.rowsModel = [
            {
                fieldId:   'articleId',
                fieldType: TitleCellNoLink,
                props:     {
                    clickHandler: this.articleClickHandler
                }
            },
            {
                fieldId:   'language',
                fieldType: LanguageCell
            },
            {
                fieldId:   'harvestDate',
                fieldType: DateContentCell,
                classes:   'notranslate'
            },
            {
                fieldId:   'matchedRiskEntityNames',
                fieldType: SimpleArrayCell,
                classes: 'notranslate'
            },
            {
                fieldId:   'pestleCategories',
                fieldType: PESTLEContentCell,
                format:    (value) => utils.parsePestleResponse(value)
            }
        ];
    }

    parsePestleResponse(value) {
        let myMap = utils.createPestleBulletMap();
        for (let i = 0; i < value.length; i++) {
            myMap[value[i].name][value[i].scoreLevel] = true;
            myMap[value[i].name]["visible"] = true;
        }
        return myMap;
    }

    componentWillMount() {
        this.initQuery();
    }

    initQuery() {
        api.loadListingTimestamp()
            .then((timestamp)=> {
                this.setState({
                    lastTimestamp: timestamp,
                    urlParams: Object.assign(
                        {},
                        this.state.urlParams,
                        { timestamp }
                    )
                })
            })
            .then(()=> {
                return api.loadCount(this.props.countUrl, this.state.urlParams);
            })
            .then((count)=>{
                this.setState({
                    articleCount: count
                });
            })
            .catch((err) => {
                xhr.handleAllErrors(err);
            });
    }


    componentWillUnmount() {
        // Enable the body scrollbar when the overlay is closed.
        //document.body.classList.remove('disable-body-scroll');
    }

    articleClickHandler(event, articleId, rowNo) {
        if (event) {
            event.preventDefault();
            this.props.showArticleView(
                articleId,
                rowNo,
                this.props.url,
                this.props.countUrl,
                this.state.urlParams);
        }
    };

    refreshData() {
        this.setState({
            articleCount: null,
            lastTimestamp: null,
        }, this.initQuery);
    }

    sortByDate() {
        let direction = this.state.urlParams.direction,
            sortBy    = this.state.urlParams.sortBy;

        this.changeUrlParams({
            sortBy:    'date',
            direction: direction === 'asc' && sortBy === 'date' ? 'desc' : 'asc'
        });
    }

    changeUrlParams(changedParams) {
        let newUrlParams = Object.assign({}, this.state.urlParams, changedParams);
        this.setState({urlParams: newUrlParams});
        this.refreshData();
    }

    render() {
        return(
            <div className="dashboard-page__articles-overlay__table">
                {this.state.lastTimestamp ?
                    <InfiniteScrollTable tableId="articlesOverlayTable"
                                         columnWidths={this.columnWidths}
                                         rowsModel={this.rowsModel}>
                        <thead className="custom-table-head">
                            <tr>
                                <th>
                                    <CountBox
                                        totalCount={this.state.articleCount}
                                        partialCount={this.state.articleCount} />

                                    <button className="button-doc-sm refresh-button" onClick={this.refreshData}>
                                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.refresh" />
                                    </button>
                                </th>
                                <th><FormattedMessage id='Dashboard_Charts_UIText_dashboard.filters.languageFilter'/></th>
                                <th>
                        <span className="sort-by-date" onClick={this.sortByDate}>
                            <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.tableHeader.date" />
                            <SortIndicator direction={this.state.urlParams.direction} />
                        </span>
                                </th>
                                <th><FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.tableHeader.entities" /></th>
                                <th><FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.tableHeader.riskAngleAndLevel" /></th>
                            </tr>
                        </thead>
                        <CustomTableBodyPostParamsWrapper url={this.props.url}
                                                          tableRequestPayload={this.state.urlParams}
                                                          verb={POST}
                        />
                    </InfiniteScrollTable>
                    : null}
            </div>
        );
    }
}

export default ArticlesTable;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Articles/ArticlesTable.jsx